<template>
  <div id="assessment-framework">
   <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Questionnaire Frameworks'" />
    <a-layout id="components-layout-demo-custom-trigger">
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.admin"
        />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
          <a-row>
            <a-col :span="24">
                <a-list item-layout="horizontal" :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }" v-if="frameworksList">
                  <a-list-item v-for="framework in frameworksList" :key="framework.id">    
                    <a-card :title="framework.title.rendered" style="margin: 8px;">                
                      <router-link :to="{ name: 'framework-details', params: { frameworkId: framework.id } }">
                        Edit this Framework
                      </router-link>
                    </a-card>
                  </a-list-item>
                </a-list>
            </a-col>
          </a-row>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';
import { Modal } from 'ant-design-vue';

import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';

export default {
  name: 'admin-assessment-framework',
  data() {
    return {
      selectedFrameworkId: '',
      radioGroupKey: 0,
      currentStep: 0,
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Questionnaire Frameworks',
          route: '/dashboard/frameworks',
        },
      ],
      comfirmVisibility: false,
      expandIconPosition: 'left',
      editedSubTitle: '',
      editedQuestionHeading: '',
      editedQuestion: '',
      isAddingHeadingQuestion: false,
      isAddingQuestion: false,
      newHeadingQuestion: '',
      newQuestion: '',
      activeDomainChangeValue: '',
    };
  },
  components: {
    dashHeader,
    dashSidebar,
  },
  methods: {
    ...mapActions('frameworks', {
      fetchFrameworks: 'fetchFrameworks',
      fetchFrameworkById: 'fetchFrameworkById',
    }),
  },

  mounted() {
    this.fetchFrameworks(); // Dispatch the action to fetch frameworks
  },
    watch: {
     frameworksList(newList) {
    if (newList && newList.length > 0) {
      // The list is now populated, do something if needed

      }
      },
    },
  computed: {
    ...mapState('frameworks', {
      // Directly use the state from the frameworks module
      frameworksList: state => state.frameworks,
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
  },
};
</script>
<style >
  span.edit-button:focus,
  span.edit-button i:focus{
    outline: none;
  }
  span.ant-input-group-addon:hover {
    background: #52c41a;
    color: #ffff;
  }
</style>
